"use client";
import {
  useCompositeGroup
} from "../__chunks/PGA74ZJ4.js";
import "../__chunks/2LDES2MP.js";
import "../__chunks/7HVFURXT.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/YIF72NQG.js";
import "../__chunks/OPTPHWV7.js";
import "../__chunks/4ROCFRIN.js";
import "../__chunks/4R3V3JGP.js";

// src/menu/menu-group.tsx
var TagName = "div";
var useMenuGroup = createHook(
  function useMenuGroup2(props) {
    props = useCompositeGroup(props);
    return props;
  }
);
var MenuGroup = forwardRef(function MenuGroup2(props) {
  const htmlProps = useMenuGroup(props);
  return createElement(TagName, htmlProps);
});
export {
  MenuGroup,
  useMenuGroup
};
